import React, { Component } from 'react';
import classNames from 'classnames';

import { withI18n, IWithI18nProps } from '../../../../components/context/i18n';
import {
  withSettings,
  IWithSettingsProps,
} from '../../../../components/context/settings';
import { withTPA, IWithTPAProps } from '../../../../components/context/tpa';
import DateTime from '../../../../components/ui/DateTime';

import EpisodeKeywords from './EpisodeKeywords';

import compose from '../../../../lib/utils/compose';

import getStyles from './EpisodePageBody.styles';
import styles from './EpisodePageBody.scss';
import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';

interface IEpisodePageBodyProps
  extends IWithI18nProps,
    IWithSettingsProps,
    IWithTPAProps {
  episode: IPodcastEpisode;
}

class EpisodePageBody extends Component<IEpisodePageBodyProps> {
  render() {
    const { episode, settings, tpa } = this.props;
    const { deviceType } = tpa.params;
    const dynamicStyles = getStyles({
      colors: settings.colors.episode,
      fonts: settings.fonts.episode,
      deviceType,
    });

    return (
      <section
        className={classNames(styles.bodyWrapper, dynamicStyles.bodyWrapper)}
      >
        <div data-hook="episode.body" className={styles.bodyContainer}>
          <div
            className={classNames(
              styles.episodeMetaInfo,
              dynamicStyles.episodeMetaInfo,
            )}
          >
            <span data-hook="episode.body.podcast-author">
              {episode.podcast.author}
            </span>
            <span className={styles.episodeMetaDotDivider}>|</span>
            <DateTime
              type="date"
              value={episode.date}
              dataHook="episode.body.date"
            />
          </div>
          <div
            data-hook="episode.body.description"
            className={classNames(
              styles.episodeDescription,
              dynamicStyles.episodeDescription,
            )}
            dangerouslySetInnerHTML={{
              __html: episode.description,
            }}
          />
          {episode.keywords.length > 0 && (
            <EpisodeKeywords keywords={episode.keywords} />
          )}
        </div>
      </section>
    );
  }
}

export default compose(withTPA, withI18n, withSettings)(EpisodePageBody);
